import { ref, watchEffect } from "vue";
import { useUserSettings } from "@/shared/settings/user-settings";

export type GROUPING_SAVE_KEY = "documentation_grouping";

export const useGroupingSetting = (groupingSaveKey: GROUPING_SAVE_KEY) => {
    const { data: savedGrouping, update, loading } = useUserSettings<boolean>(groupingSaveKey);
    const initialized = ref(false);
    const isGrouped = ref(false);
    const isE2E = location.href.includes("playwright");

    watchEffect(() => {
        if (loading.value || initialized.value) return;
        try {
            if (savedGrouping.value !== undefined && !isE2E) {
                isGrouped.value = savedGrouping.value;
            }
        } finally {
            initialized.value = true;
        }
    });

    const save = async (value: boolean) => {
        //Don't save for e2e
        if (isE2E) return;

        await update(value);
    };

    return { isGrouped, save, initialized };
};
